import React, { useContext, useState, useEffect } from "react";
import "../../../styles/ColorApp.css";
import ColorRow from "./ColorRow";
import Color from "color";
import ColorAppHeader from "./ColorAppHeader";
import { ClientContext } from "../../../contexts/ClientContext";
import { useParams } from "react-router-dom";

const ColorApp = () => {
  const { currentSet, currentClient, getSetData, clients, getClient } = useContext(ClientContext);
  const [paletteName, setPaletteName] = useState("Loading...");
  const [colorRows, setColorRows] = useState([]);
  const { clientid, setid } = useParams();

  useEffect(() => {
    if (currentClient && currentSet) {
      setPaletteName(currentClient.name + "-" + currentSet.setName);
      setColorRows(currentSet.ColorRows);
    }
  }, [clients, currentClient, currentSet]);

  useEffect(() => {
    if (!currentSet) {
      if (!currentClient) {
        getClient(clientid);
      }
      getSetData(setid);
    }
  }, [clients, currentClient, currentSet]);

  const renderColorRows = () => {
    if (currentSet) {
      return Object.values(colorRows).map((colorOption) => {
        return (
          <ColorRow
            rowLabel={colorOption.color}
            key={colorOption.color}
            pickedColor={Color(colorOption.pickedColor.toLowerCase())}
          />
        );
      });
    } else {
      return null;
    }
  };

  return (
    <>
      <ColorAppHeader
        paletteName={paletteName}
        colorRows={colorRows}
        currentClient={currentClient}
      />
      <div className="app color-app">{renderColorRows()}</div>
    </>
  );
};

export default ColorApp;
